// @flow

/**
 * Module dependencies.
 */

import { colors, defaultTransition, states, units } from 'client/styles';
import { compose, defaultProps } from 'recompose';
import { createElement } from 'react';
import styled from 'styled-components';

/**
 * Prop types definition.
 */

type Props = {
  children?: React$Element<*> | Array<React$Element<*>> | string,
  element: ReactClass<*> | string,
  fontWeight: Number,
  size?: string,
  theme?: string,
  [key: string]: any
};

/**
 * Default theme color.
 */

const defaultColor = colors.brandPrimary;

/**
 * Styles.
 */

const createStyledElement = (element : any): any => styled(element)`
  background-color: transparent;
  border-radius: 100px;
  border: 2px solid;
  display: inline-block;
  height: 48px;
  line-height: 27px;
  min-width: 170px;
  overflow: hidden;
  padding: ${units(1)} ${units(2)};
  text-align: center;
  transition-property: background-color, border-color, color, opacity;
  transition: ${defaultTransition};
  white-space: nowrap;

  ${({ themeColor = defaultColor }) => `
    border-color: ${themeColor};
    color: ${themeColor};
  `};

  ${states.action`
    outline: none;
    cursor: pointer;
    text-decoration: none;
  `};

  ${states.interaction`
    color: ${colors.white};
    text-decoration: none;

    ${({ themeColor = defaultColor }) => `
      background-color: ${themeColor};
    `};
  `};
`;

/**
 * `ButtonComponent` component.
 */

function ButtonComponent(props: Props): React$Element<*> {
  const {
    children,
    element,
    ...rest
  } = props;

  return createElement(
    createStyledElement(element),
    { ...rest },
    children
  );
}

/**
 * Export `Button` component.
 */

export const Button = compose(
  defaultProps({ element: 'button' })
)(ButtonComponent);



// WEBPACK FOOTER //
// ../src/client/components/core/buttons/button.js